import React from "react";
import ConferenceItems from "../conference_items";
import ProjectItems from "../project_items";
import Navbar from "../navbar";
import Footer from "../footer";
function Projects() {
  return (
    <div>
      <Navbar />
      <div className="projects__page-container  p-5">
        <h1 className="projects__page-heading text-center site__heading">
          Publications and Presentations
        </h1>
        <div className="projects__data-box">
          <ProjectItems />
          <ConferenceItems />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Projects;
